import { FC } from 'react';
// components
import EditProductSizeComponent from 'components/main/ProductSize/Edit';

const EditProductSize: FC = () => <EditProductSizeComponent />;

export default EditProductSize;
